import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Alert, Button, Card, Divider, Input, Select } from 'antd';
import { LockOutlined, LoginOutlined, UserOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'core/store';
import Cookies from 'portal-cookie';
import { Title } from '@mui/icons-material';


const Login = () => {
	const dispatch = useDispatch();

	const pending = useSelector(state => state.auth.pending),
		showPasswordChange = useSelector(state => state.auth.showPasswordChange),
		showRelog = useSelector(state => state.auth.showRelog),
		verifyingToken = useSelector(state => state.auth.verifyingToken),
		systemsRequested = useSelector(state => state.auth.systemsRequested),
		accessibleSystems = useSelector(state => state.auth.accessibleSystems),
		userDataArray = useSelector(state => state.auth.userDataArray),
		selectedSystem = useSelector(state => state.auth.selectedSystem),
		errors = useSelector(state => state.auth.errors);

	const [userEmail, setUserEmail] = useState('');
	const [userPassword, setUserPassword] = useState('');
	const [resetPassword1, setResetPassword1] = useState('');
	const [resetPassword2, setResetPassword2] = useState('');

	const authToken = Cookies.get('authToken');
	//console.log('authToken', authToken)
	//console.log('accessibleSystems', accessibleSystems)
	//console.log('userDataArray', userDataArray)
	//console.log('selectedSystem', selectedSystem)
	//console.log('showPasswordChange', showPasswordChange);
	//console.log('showRelog', showRelog);

	const systemSelectRef = useRef(null);
	const passwordInputRef = useRef(null);

	useEffect(() => {
		console.log('heartbeat');
		dispatch(actions.auth.heartbeat());
	}, []);

	const handleGetSystem = () => {
		console.log('[Login] handleGetSystem')
		//console.log('userEmail:', userEmail)
		dispatch(actions.auth.getSystems(userEmail));
		if (systemSelectRef.current) {
			systemSelectRef.current.focus();
		}
	};

	const verifyToken = useCallback((token) => {
		console.log('[Login] verifyToken useEffect')
		dispatch(actions.auth.verifyToken(token));
	}, [dispatch]);

	const handleSelectSystem = (sys) => {
		console.log('[Login] handleSelectSystem', sys)
		if (!!sys && sys !== undefined) {
			dispatch(actions.auth.chooseSystem(sys));
		} else {
			console.log('[Login] handleSelectSystem else')
		}

	}

	useEffect(() => {
		console.log('[Login] useEffect changes')
		//console.log(authToken)
		//console.log('showPasswordChange', showPasswordChange);

		if (authToken && !showPasswordChange && !showRelog) {
			verifyToken(authToken);
		}
	}, [
		authToken,
		verifyToken,
		showPasswordChange,
		showRelog,
	]);

	useEffect(() => {
		console.log('[Login] useEffect showRelog changes; ', showRelog)

		if (showRelog) {
			setUserPassword('')
			setResetPassword1('')
			setResetPassword2('')
		}
	}, [
		showRelog,
	]);

	// useEffect(() => {
	// 	console.debug('DEBUG userEmail changes')
	// }, [userEmail]);

	// useEffect(() => {
	// 	console.debug('DEBUG userPassword changes')
	// }, [userPassword]);

	useEffect(() => {
		console.log('[Login] selectedSystem changes')
	}, [selectedSystem]);

	const handleChangeUserEmail = (e) => {
		console.log('[Login] handleChangeUserEmail', e.target.value)
		if (!selectedSystem) {
			// prevent the browser from changing the email
			setUserEmail(e.target.value)
		}
	};

	const handleChangeUserPassword = (e) => {
		console.log('[Login] handleChangeUserPassword', e.target.value)
		setUserPassword(e.target.value)
	};

	const handleChangeResetPassword1 = (e) => {
		console.log('[Login] handleChangeResetPassword1', e.target.value)
		setResetPassword1(e.target.value)
	};

	const handleChangeResetPassword2 = (e) => {
		console.log('[Login] handleChangeResetPassword2', e.target.value)
		setResetPassword2(e.target.value)
	};

	const handleUsernamePressEnter = (e) => {
		//console.log('[Login] handleUsernamePressEnter')
		handleGetSystem();
	};

	const handleSystemPressEnter = (e) => {
		//console.log('[Login] handleSystemPressEnter', e.code)
		if (e.code === 'Enter' && passwordInputRef.current) {
			//console.log('[Login] passwordInputRef focus')
			passwordInputRef.current.focus();
		}
	};

	const handlePasswordPressEnter = (e) => {
		//console.log('handlePasswordPressEnter')
		handleLogin();
	};

	const handleLogin = (e) => {
		console.log('[Login] handleLogin')
		dispatch(actions.auth.handleLogin({ username: userEmail, password: userPassword }));
	};

	const handleSubmit = (e) => {
		console.log('[Login] handleSubmit')
		e.preventDefault();

		if (showPasswordChange) {
			handlePasswordChange();
		} else if (selectedSystem) {
			handleLogin();
		} else {
			handleGetSystem();
		}
	};

	const handlePasswordChange = () => {
		let values = {
			resetPassword1: resetPassword1,
			resetPassword2: resetPassword2
		};
		dispatch(actions.auth.handlePasswordChange(values));
	};

	if (verifyingToken) {
		console.log('[Login] verifyingToken / rendering null')
		return null;
	}

	return (
		<div className="ts_home_content_container login_form">

			<Card title={<div><LoginOutlined /> Log In</div>} className="ts_content_container ts_portal_card">

				{errors.map(message => (
					<Alert className="login_alert" message={message} key={message} type="error" />
				))}

				{showPasswordChange &&
					<Alert
						className="login_alert"
						message="You must change your password before logging in. Please set your new password below."
					/>
				}

				{showRelog &&
					<Alert
						className="login_alert"
						message="Your password has been successfully changed. Please log in again with your new password."
					/>
				}
				<form onSubmit={handleSubmit} className="system_selection_form">
					<Input
						prefix={<UserOutlined className="site_form_item_icon" />}
						onChange={handleChangeUserEmail}
						onPressEnter={handleUsernamePressEnter}
						//placeholder="User Name"
						placeholder="Email"
						value={userEmail}
						disabled={pending}
						inputMode={'email'}
						type={'email'}
						name={'email'}
						autoComplete={!selectedSystem ? 'email' : 'false'} // NOTE yes false is supposed to be a string
					/>

					{
						!systemsRequested &&
						<>
							<Button
								type="primary"
								className="ts_full_width"
								loading={pending}
								onClick={handleGetSystem}
							>
								{'Log In'}
							</Button>
						</>
					}

					{
						<Select
							className={accessibleSystems.length > 0 ? 'system_select' : 'system_select_hidden'}
							placeholder={'Select Company'}
							onChange={(s) => {
								handleSelectSystem(s);
							}}
							//onFocus={() => console.log('system_select onFocus')}
							onInputKeyDown={handleSystemPressEnter}
							ref={systemSelectRef}
						>

							<Select.Option key="system_select" value="">Select Company</Select.Option>
							{(accessibleSystems || []).map(sys => (
								<Select.Option key={sys} value={sys}>
									{sys}
								</Select.Option>
							))}
						</Select>
					}

					{
						<>
							{!showPasswordChange &&
								<Input.Password
									className={selectedSystem ? null : 'input_hidden'}
									prefix={<LockOutlined className="site_form_item_icon" />}
									placeholder="Password"
									value={userPassword}
									//onFocus={() => console.log('Password onFocus')}
									onPressEnter={handlePasswordPressEnter}
									onChange={handleChangeUserPassword}
									autoComplete={'password'} // if autocomplete becomes and issue use "new-password"
									ref={passwordInputRef}
								/>
							}

							{showPasswordChange &&

								<Input.Password
									prefix={<LockOutlined className="site_form_item_icon" />}
									value={resetPassword1}
									onChange={handleChangeResetPassword1}
									type="password"
									placeholder="New Password"
									disabled={pending}
								/>
							}

							{showPasswordChange &&

								<Input.Password
									prefix={<LockOutlined className="site-form-item-icon" />}
									value={resetPassword2}
									onChange={handleChangeResetPassword2}
									type="password"
									placeholder="Re-enter New Password"
									disabled={pending}
								/>
							}

							{(selectedSystem && userPassword && userPassword.length > 1) &&
								<Button
									type="primary"
									className="ts_full_width"
									loading={pending}
									onClick={showPasswordChange
										? handlePasswordChange
										: handleLogin}
								>
									{showPasswordChange ? 'Reset Password' : 'Log In'}
								</Button>
							}
						</>
					}

				</form>
			</Card>
		</div>

	);


};

export default Login;
